import Aura from "@primeng/themes/aura";
import { PrimeNGConfigType } from "primeng/config";
import { MarkedOptions } from "ngx-markdown";

/**
 * Configurazione di PrimeNG (tema e traduzioni) condivisa da app (main.ts) e Storybook (.storybook/preview.ts):
 * una sola fonte, così le storie mostrano i componenti PrimeNG esattamente come nell'app
 */
export const PRIMENG_CONFIG: PrimeNGConfigType = {
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: "none",
      cssLayer: false
    }
  },
  translation: {
    // Traduzioni primeNG TODO rendere dinamiche per lingua
    accept: "Accetta",
    reject: "Rifiuta",
    choose: "Scegli",
    upload: "Carica",
    cancel: "Annulla",
    pending: "In attesa",
    dayNames: [
      "Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"
    ],
    dayNamesShort: [
      "Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"
    ],
    dayNamesMin: [
      "Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"
    ],
    monthNames: [
      "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"
    ],
    monthNamesShort: [
      "Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"
    ],
    chooseYear: "Scegli Anno",
    chooseMonth: "Scegli Mese",
    chooseDate: "Scegli Data",
    prevDecade: "Decade Precedente",
    nextDecade: "Decade Successiva",
    prevYear: "Anno Precedente",
    nextYear: "Anno Successivo",
    prevMonth: "Mese Precedente",
    nextMonth: "Mese Successivo",
    prevHour: "Ora Precedente",
    nextHour: "Ora Successiva",
    prevMinute: "Minuto Precedente",
    nextMinute: "Minuto Successivo",
    prevSecond: "Secondo Precedente",
    nextSecond: "Secondo Successivo",
    am: "am",
    pm: "pm",
    today: "Oggi",
    weekHeader: "Sett",
    firstDayOfWeek: 1,
    dateFormat: "dd/mm/yy",
    clear: "Cancella",
    apply: "Applica"
  }
};

/**
 * Opzioni del renderer markdown (ngx-markdown) condivise da app e Storybook
 */
export const MARKED_OPTIONS_CONFIG: MarkedOptions = {
  breaks: true, // Converte \n in <br>
  gfm: true // GitHub Flavored Markdown
};
